import {
  FormControl,
  FormHelperText,
  FormLabel,
  Grid,
  TextField,
} from '@mui/material';
import React from 'react';
import { Control, Controller, FieldError, FieldErrors } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { legacyTranslationInterpolation } from '~/utils/helper';

import { AnswerPreProcess, SurveyQuestion } from '../types';

import { useSxStyles } from './useStyles';

type Props = {
  question: SurveyQuestion;
  control: Control;
  errors: FieldErrors<AnswerPreProcess>;
};

export const FreeText: React.FC<Props> = ({ control, question, errors }) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();
  return (
    <Grid
      item
      container
      xs={12}
      key={question.index}
      justifyContent="space-between"
    >
      <FormControl sx={sxStyles.formControl} fullWidth>
        <Grid item sx={{ ...sxStyles.question, ...sxStyles.stretch }}>
          <FormLabel sx={sxStyles.formControlLabel}>
            {question.text}
            <FormHelperText id={`${question.index}-helper-free-text`}>
              {t('label_enter_up_to_chars', {
                count: 3000,
                interpolation: legacyTranslationInterpolation,
              })}
            </FormHelperText>
          </FormLabel>
        </Grid>
        <Grid item sx={sxStyles.stretch}>
          <Controller
            control={control}
            name={`${question.id}`}
            rules={{
              required: `${t('laThisRequired')}`,
              maxLength: {
                value: 3000,
                message: `${t('laErrorMaxTextLen1')} 3000`,
              },
            }}
            defaultValue=""
            render={({ field }) => (
              <TextField
                {...field}
                id={`${question.id}-${question.type}-question`}
                label={''}
                multiline
                helperText={
                  !!errors[question.id]
                    ? (errors[question.id] as FieldError).message
                    : null
                }
                error={!!errors[question.id]}
                rows="5"
                margin="normal"
                fullWidth
              />
            )}
          />
        </Grid>
      </FormControl>
    </Grid>
  );
};
